<ngx-spinner
  name="main"
  bdColor="rgba(0, 0, 0, 0.75)"
  [fullScreen]="true"
  [disableAnimation]="true"
  [zIndex]="2000"
  [template]="spinnerTemplate"
></ngx-spinner>
